import { ProductModule } from "@/components/site/ProductModule";

export const ProductsSection = ({ c, products, onCta }) => (
  <section id="products" aria-labelledby="products-title" data-track-section="products" data-nexus-s=".24" data-nexus-dim=".30" className="section">
    <div className="wrap">
      <div className="section-head reveal">
        <p className="kicker">{c.kicker}</p>
        <h2 id="products-title" className="section-title">{c.title}</h2>
        <p className="lede">{c.lede}</p>
      </div>
      <div className="product-suite" data-testid="product-suite">
        {products.map((p, i) => <ProductModule key={p.slug} p={p} index={i} />)}
      </div>
      <p className="future-line" data-testid="future-platforms-line">
        {c.future_line}{" "}
        <a href="#contact" onClick={() => onCta("future-talk", "Partnership")} className="text-link" data-testid="future-platforms-link">
          {c.future_link}
        </a>
      </p>
    </div>
  </section>
);
